import { ILocation } from 'shared/types/location';

export const MOSCOW_ID = 1;
export const MOSCOW_REGION_ID = 4593;
export const MOSCOW_AND_REGION = [MOSCOW_ID, MOSCOW_REGION_ID];
export const MOSCOW_AND_REGION_ID = -1;

export const SPB_ID = 2;
export const SPB_REGION_ID = 4588;
export const SPB_AND_REGION = [SPB_ID, SPB_REGION_ID];
export const SPB_AND_REGION_ID = -2;

export const MOSCOW_WITH_SPB_AND_REGIONS = [...MOSCOW_AND_REGION, ...SPB_AND_REGION];

export const MOSCOW_LOCATION = {
  name: 'Москва',
  hasDistricts: true,
  hasNeighbors: false,
  parentId: null,
  id: 1,
  lat: 55.7557,
  boundedBy: {
    upperCorner: {
      lat: 56.021224,
      lng: 37.967428,
    },
    lowerCorner: {
      lat: 55.142175,
      lng: 36.803101,
    },
  },
  hasHighway: false,
  mainTownId: null,
  fullName: 'Москва',
  hasMetro: true,
  lng: 37.6213,
  displayName: 'Москва',
  hasRegionalDistricts: true,
};

export const SPB_LOCATION = {
  boundedBy: {
    upperCorner: {
      lat: 60.244837,
      lng: 30.759691,
    },
    lowerCorner: {
      lat: 59.633783,
      lng: 29.42981,
    },
  },
  hasMetro: true,
  hasNeighbors: false,
  displayName: 'Санкт-Петербург',
  name: 'Санкт-Петербург',
  hasHighway: false,
  hasDistricts: true,
  lng: 30.3058,
  lat: 59.9385,
  fullName: 'Санкт-Петербург',
  id: 2,
  parentId: null,
  mainTownId: null,
  hasRegionalDistricts: false,
};

export const LOCATION_BY_ID: Record<number, ILocation> = {
  [MOSCOW_ID]: MOSCOW_LOCATION,
  [SPB_ID]: SPB_LOCATION,
};
